// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input,
optgroup,
select,
textarea,
label,
a {
  font-family: "Open Sans", sans-serif !important;
  color: #2f2f2f;
}

button {
  font-family: "Source Sans Pro", sans-serif !important;
  color: #2f2f2f;
}

.login-container {
  background-color: white;
}

.logo {
  margin-bottom: 15px;
}

.login-container .d-flex {
  display: flex !important;
}

.left-content,
.right-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.left-content {
  width: 40%;
  position: relative;
  padding: 20px;
}

.right-content {
  display: flex !important;
  width: 60%;
  height: 100%;
  position: relative;
  padding: 20px;
  background-color: #f0f7ff;
  background-image: url("/assets/cablepro/img/Group9.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 95vh;
  width: 340px;
}

.center-content img {
  max-width: 100%;
  height: auto;
}

.maintext {
  font-family: "Open Sans", sans-serif !important;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  color: #444444;
  margin-bottom: 0px;
}

.btn-group-vertical {
  width: 100%;
}

.btn-custom,
.btn-inline {
  background-color: #fff;
  border: 1px solid #2f2f2f;
  border-radius: 30px !important;
  width: 100%;
  margin-bottom: 15px;
  font-size: 12px;
  padding: 0.375rem 0.75rem !important;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif !important;
}

.btn-custom div {
  width: 65%;
  text-align: left;
}

.btn-custom span {
  vertical-align: middle;
  margin-left: 5px;
}

.btn-blue {
  background-color: #4285f4 !important;
  border: 1px solid #4285f4 !important;
  color: white !important;
}

.btn-blue:hover {
  background-color: #71a4f6 !important;
}

.btn-custom:hover {
  background-color: #f4f5f8;
}

.btn-inline {
  width: auto;
  padding: 5px 15px;
  /* Adjust padding for inline appearance */
  display: inline-block;
}

.full-height {
  height: 100vh;
}

.position-relative {
  position: relative;
}

.header {
  font-size: 29px;
  margin-bottom: 10px;
  font-family: "Open Sans", sans-serif !important;
  font-weight: 600;
}

.line-text-20 {
  font-size: 20px;
  margin-bottom: 5px;
  font-family: "Open Sans", sans-serif !important;
}

.line-text-18 {
  font-size: 18px;
  margin-bottom: 5px;
  font-family: "Open Sans", sans-serif !important;
}

.line-text-15 {
  font-size: 15px;
  margin-bottom: 20px;
  font-family: "Open Sans", sans-serif !important;
}

.image-box-container {
  display: grid !important;
  grid-template-columns: repeat(2, 1fr);
  /* Exactly two columns */
  gap: 10px;
  justify-content: center;
}

.image-box {
  padding: 0px;
  max-width: 337px;
  /* Set max-width for image boxes */
  width: 100%;
  /* Adjust width to fit the column */
  box-sizing: border-box;
  text-align: center;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}

.image-box a {
  text-decoration: none;
}

.image-box:nth-child(odd) {
  justify-self: end;
}

.image-box .image-box-content {
  padding: 20px;
  height: 50%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.image-box-content a {
  text-decoration: none;
}

.image-box .title {
  font-size: 18px;
  font-weight: bold;
  /* Make the title bold */
  margin-bottom: 5px;
  font-family: "Open Sans", sans-serif !important;
}

.image-box .description {
  font-size: 15px;
  /* Adjust font size for description */
  font-family: "Open Sans", sans-serif !important;
}

.image-box img {
  width: 100%;
  height: 50%;
  /* object-fit: cover; */
  border-radius: 10px 10px 0 0;
}

.additional-buttons {
  text-align: center;
  margin-top: 30px;
}

.additional-buttons span {
  margin-right: 10px;
  font-size: 12px;
  font-family: "Open Sans", sans-serif !important;
  font-size: 15px;
  color: #212529;
}

.additional-buttons button {
  margin-bottom: 0px;
  height: 48px !important;
  width: 146px;
  font-size: 18px;
}

.additional-buttons button:hover {
  background-color: #f4f5f8;
}

.login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-form .control {
  width: 100%;
  margin-bottom: 10px;
}

.form-input {
  padding: 8px 12px;
  border: 1px solid #90a4ae;
  border-radius: 30px !important;
  /* Match the button border radius */
  background-color: #fff;
  /* Match the button background color */
  width: 100%;
  box-sizing: border-box;
  font-family: "Source Sans Pro", sans-serif !important;
  height: 52px;
  font-size: 18px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif !important;
}

.control .checkboxstyle .login-controls {
  width: 100%;
  margin-top: 20px;
}

.login-with-email {
  display: inline;
  text-decoration: none;
  color: #4285f4;
  margin-left: 5px;
}

.login-with-email i {
  font-size: 22px;
}

.login-with-email-span {
  margin-left: 10px;
  font-size: 18px;
}

.checkboxstyle {
  height: 20px;
  width: 20px;
  top: 3px;
  position: relative;
  margin-right: 10px;
}

.signin-other-title {
  position: relative;
  width: 100%;
  text-align: center;
}

.signin-other-title .title {
  display: inline-block;
  position: relative;
  z-index: 9;
  background-color: #fff;
  padding: 20px;
  color: #90a4ae;
  margin: 0;
}

.signin-other-title:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  border-top: 1px solid #90a4ae;
  top: 29px;
}

:host ::ng-deep .form-control-feedback {
  font-size: 15px !important;
}

validation-messages {
  font-family: "Open Sans", sans-serif;
}

.resend-code-link {
  color: #4285f4;
  font-size: 15px;
}

.resend-code-text {
  color: #212529;
  font-size: 15px;
}

.footer-area {
  background-color: white;
  width: 100%;
}

.footer-area .footer-text {
  font-family: "Open Sans", sans-serif !important;
  font-size: 15px;
}

.default-color {
  color: #4285f4;
}

.checkboxstyle {
  margin-left: 5px;
}

.text {
  color: #90a4ae;
  font-size: 18px !important;
}

.support-number a {
  color: #4285f4 !important;
  text-decoration: none;
}

.forgot-password {
  text-decoration: underline;
  margin-top: 20px;
  color: #4285f4;
  font-size: 15px;
}

.signup-link {
  text-decoration: underline;
  margin-top: 10px;
  color: #4285f4;
  font-size: 15px;
}

.passwordless-text {
  font-size: 15px !important;
}

.passwordless-section {
  margin-top: 20px;
  margin-bottom: 20px !important;
}

.margin-top-20 {
  margin-top: 20px;
}

@media (max-width: 767px) {
  .left-content,
  .right-text-only {
    width: 100%;
  }
  .full-height {
    height: auto;
  }
  .right-text-only {
    display: none !important;
  }
  .left-content {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    height: 100vh;
  }
  .image-box-container {
    display: none !important;
  }
  .position-relative {
    margin-top: 88px;
  }
}
@media (max-width: 1250px) {
  .terms-privacy {
    display: block !important;
  }
}
@media (min-width: 768px) and (max-width: 800px) {
  .btn-custom div {
    width: 85%;
    text-align: left;
  }
}
@media (min-width: 768px) and (max-width: 932px) {
  .image-box-container {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: unset !important;
    overflow-y: auto !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/account/login/login.component.scss"],"names":[],"mappings":"AAGA;;;;;;EAMI,+CAAA;EACA,cAAA;AAFJ;;AAKA;EACI,qDAAA;EACA,cAAA;AAFJ;;AAKA;EACI,uBAAA;AAFJ;;AAKA;EACI,mBAAA;AAFJ;;AAKA;EACI,wBAAA;AAFJ;;AAKA;;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,UAAA;EACA,kBAAA;EACA,aAAA;AAFJ;;AAKA;EACI,wBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,wDAAA;EACA,4BAAA;EACA,sBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;AAFJ;;AAKA;EACI,eAAA;EACA,YAAA;AAFJ;;AAKA;EACI,+CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAxEkB;EAyElB,cAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,WAAA;AAFJ;;AAKA;;EAEI,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eA/FgB;EAgGhB,gBAAA;EACA,+CAAA;AAFJ;;AAKA;EACI,UAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,sBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,oCAAA;EACA,oCAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,oCAAA;AAFJ;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI,WAAA;EACA,iBAAA;EACA,yCAAA;EACA,qBAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,kBAAA;EACA,+CAAA;AAFJ;;AAKA;EACI,eAzJgB;EA0JhB,kBAAA;EACA,+CAAA;AAFJ;;AAKA;EACI,eA9JkB;EA+JlB,mBAAA;EACA,+CAAA;AAFJ;;AAKA;EACI,wBAAA;EACA,qCAAA;EACA,wBAAA;EACA,SAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,mCAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;AAFJ;;AAKA;EACI,qBAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,qBAAA;AAFJ;;AAKA;EACI,eA/MgB;EAgNhB,iBAAA;EACA,wBAAA;EACA,kBAAA;EACA,+CAAA;AAFJ;;AAKA;EACI,eAtNkB;EAuNlB,qCAAA;EACA,+CAAA;AAFJ;;AAKA;EACI,WAAA;EACA,WAAA;EACA,uBAAA;EACA,4BAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,eAAA;EACA,+CAAA;EACA,eA3OkB;EA4OlB,cAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,eApPgB;AAkPpB;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,WAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,yBAAA;EACA,8BAAA;EACA,mCAAA;EACA,sBAAA;EACA,sCAAA;EACA,WAAA;EACA,sBAAA;EACA,qDAAA;EACA,YAAA;EACA,eAjRgB;EAkRhB,gBAAA;EACA,+CAAA;AAFJ;;AAKA;EACI,WAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,eAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,eAxSgB;AAsSpB;;AAKA;EACI,YAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;AAFJ;;AAKA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,6BAAA;EACA,SAAA;AAFJ;;AAKA;EACI,0BAAA;AAFJ;;AAKA;EACI,oCAAA;AAFJ;;AAKA;EACI,cAAA;EACA,eAvVkB;AAqVtB;;AAKA;EACI,cAAA;EACA,eA5VkB;AA0VtB;;AAKA;EACI,uBAAA;EACA,WAAA;AAFJ;;AAKA;EACI,+CAAA;EACA,eAtWkB;AAoWtB;;AAKA;EACI,cAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,cAAA;EACA,0BAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,qBAAA;AAFJ;;AAKA;EACI,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,eA/XkB;AA6XtB;;AAKA;EACI,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,eAtYkB;AAoYtB;;AAKA;EACI,0BAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,8BAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EAEI;;IAEI,WAAA;EAHN;EAME;IACI,YAAA;EAJN;EAOE;IACI,wBAAA;EALN;EAQE;IACI,wBAAA;IACA,iCAAA;IACA,8BAAA;IACA,kCAAA;IACA,aAAA;EANN;EASE;IACI,wBAAA;EAPN;EAUE;IACI,gBAAA;EARN;AACF;AAWA;EACI;IACI,yBAAA;EATN;AACF;AAYA;EACI;IACI,UAAA;IACA,gBAAA;EAVN;AACF;AAaA;EACI;IACI,wBAAA;IACA,iCAAA;IACA,8BAAA;IACA,iCAAA;IACA,2BAAA;EAXN;AACF","sourcesContent":["$primary-font-size: 18px;\n$secondary-font-size: 15px;\n\ninput,\noptgroup,\nselect,\ntextarea,\nlabel,\na {\n    font-family: \"Open Sans\", sans-serif !important;\n    color: #2f2f2f;\n}\n\nbutton {\n    font-family: \"Source Sans Pro\", sans-serif !important;\n    color: #2f2f2f;\n}\n\n.login-container {\n    background-color: white;\n}\n\n.logo {\n    margin-bottom: 15px;\n}\n\n.login-container .d-flex {\n    display: flex !important;\n}\n\n.left-content,\n.right-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.left-content {\n    width: 40%;\n    position: relative;\n    padding: 20px;\n}\n\n.right-content {\n    display: flex !important;\n    width: 60%;\n    height: 100%;\n    position: relative;\n    padding: 20px;\n    background-color: #f0f7ff;\n    background-image: url(\"/assets/cablepro/img/Group9.png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n.center-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 95vh;\n    width: 340px;\n}\n\n.center-content img {\n    max-width: 100%;\n    height: auto;\n}\n\n.maintext {\n    font-family: \"Open Sans\", sans-serif !important;\n    font-style: normal;\n    font-weight: 600;\n    font-size: $secondary-font-size;\n    color: #444444;\n    margin-bottom: 0px;\n}\n\n.btn-group-vertical {\n    width: 100%;\n}\n\n.btn-custom,\n.btn-inline {\n    background-color: #fff;\n    border: 1px solid #2f2f2f;\n    border-radius: 30px !important;\n    width: 100%;\n    margin-bottom: 15px;\n    font-size: 12px;\n    padding: 0.375rem 0.75rem !important;\n    height: 52px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: $primary-font-size;\n    font-weight: 400;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.btn-custom div {\n    width: 65%;\n    text-align: left;\n}\n\n.btn-custom span {\n    vertical-align: middle;\n    margin-left: 5px;\n}\n\n.btn-blue {\n    background-color: #4285f4 !important;\n    border: 1px solid #4285f4 !important;\n    color: white !important;\n}\n\n.btn-blue:hover {\n    background-color: #71a4f6 !important;\n}\n\n.btn-custom:hover {\n    background-color: #f4f5f8;\n}\n\n.btn-inline {\n    width: auto;\n    padding: 5px 15px;\n    /* Adjust padding for inline appearance */\n    display: inline-block;\n}\n\n.full-height {\n    height: 100vh;\n}\n\n.position-relative {\n    position: relative;\n}\n\n.header {\n    font-size: 29px;\n    margin-bottom: 10px;\n    font-family: \"Open Sans\", sans-serif !important;\n    font-weight: 600;\n}\n\n.line-text-20 {\n    font-size: 20px;\n    margin-bottom: 5px;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.line-text-18 {\n    font-size: $primary-font-size;\n    margin-bottom: 5px;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.line-text-15 {\n    font-size: $secondary-font-size;\n    margin-bottom: 20px;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.image-box-container {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr);\n    /* Exactly two columns */\n    gap: 10px;\n    justify-content: center;\n}\n\n.image-box {\n    padding: 0px;\n    max-width: 337px;\n    /* Set max-width for image boxes */\n    width: 100%;\n    /* Adjust width to fit the column */\n    box-sizing: border-box;\n    text-align: center;\n    border-radius: 10px;\n    background-color: white;\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 10%);\n}\n\n.image-box a {\n    text-decoration: none;\n}\n\n.image-box:nth-child(odd) {\n    justify-self: end;\n}\n\n.image-box .image-box-content {\n    padding: 20px;\n    height: 50%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.image-box-content a {\n    text-decoration: none;\n}\n\n.image-box .title {\n    font-size: $primary-font-size;\n    font-weight: bold;\n    /* Make the title bold */\n    margin-bottom: 5px;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.image-box .description {\n    font-size: $secondary-font-size;\n    /* Adjust font size for description */\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.image-box img {\n    width: 100%;\n    height: 50%;\n    /* object-fit: cover; */\n    border-radius: 10px 10px 0 0;\n}\n\n.additional-buttons {\n    text-align: center;\n    margin-top: 30px;\n}\n\n.additional-buttons span {\n    margin-right: 10px;\n    font-size: 12px;\n    font-family: \"Open Sans\", sans-serif !important;\n    font-size: $secondary-font-size;\n    color: #212529;\n}\n\n.additional-buttons button {\n    margin-bottom: 0px;\n    height: 48px !important;\n    width: 146px;\n    font-size: $primary-font-size;\n}\n\n.additional-buttons button:hover {\n    background-color: #f4f5f8;\n}\n\n.login-form {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.login-form .control {\n    width: 100%;\n    margin-bottom: 10px;\n}\n\n.form-input {\n    padding: 8px 12px;\n    border: 1px solid #90a4ae;\n    border-radius: 30px !important;\n    /* Match the button border radius */\n    background-color: #fff;\n    /* Match the button background color */\n    width: 100%;\n    box-sizing: border-box;\n    font-family: \"Source Sans Pro\", sans-serif !important;\n    height: 52px;\n    font-size: $primary-font-size;\n    font-weight: 400;\n    font-family: \"Open Sans\", sans-serif !important;\n}\n\n.control .checkboxstyle .login-controls {\n    width: 100%;\n    margin-top: 20px;\n}\n\n.login-with-email {\n    display: inline;\n    text-decoration: none;\n    color: #4285f4;\n    margin-left: 5px;\n}\n\n.login-with-email i {\n    font-size: 22px;\n}\n\n.login-with-email-span {\n    margin-left: 10px;\n    font-size: $primary-font-size;\n}\n\n.checkboxstyle {\n    height: 20px;\n    width: 20px;\n    top: 3px;\n    position: relative;\n    margin-right: 10px;\n}\n\n.signin-other-title {\n    position: relative;\n    width: 100%;\n    text-align: center;\n}\n\n.signin-other-title .title {\n    display: inline-block;\n    position: relative;\n    z-index: 9;\n    background-color: #fff;\n    padding: 20px;\n    color: #90a4ae;\n    margin: 0;\n}\n\n.signin-other-title:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 1px;\n    left: 0;\n    right: 0;\n    border-top: 1px solid #90a4ae;\n    top: 29px;\n}\n\n:host ::ng-deep .form-control-feedback {\n    font-size: $secondary-font-size !important;\n}\n\nvalidation-messages {\n    font-family: \"Open Sans\", sans-serif;\n}\n\n.resend-code-link {\n    color: #4285f4;\n    font-size: $secondary-font-size;\n}\n\n.resend-code-text {\n    color: #212529;\n    font-size: $secondary-font-size;\n}\n\n.footer-area {\n    background-color: white;\n    width: 100%;\n}\n\n.footer-area .footer-text {\n    font-family: \"Open Sans\", sans-serif !important;\n    font-size: $secondary-font-size;\n}\n\n.default-color {\n    color: #4285f4;\n}\n\n.checkboxstyle {\n    margin-left: 5px;\n}\n\n.text {\n    color: #90a4ae;\n    font-size: $primary-font-size !important;\n}\n\n.support-number a {\n    color: #4285f4 !important;\n    text-decoration: none;\n}\n\n.forgot-password {\n    text-decoration: underline;\n    margin-top: 20px;\n    color: #4285f4;\n    font-size: $secondary-font-size;\n}\n\n.signup-link {\n    text-decoration: underline;\n    margin-top: 10px;\n    color: #4285f4;\n    font-size: $secondary-font-size;\n}\n\n.passwordless-text {\n    font-size: $secondary-font-size !important;\n}\n\n.passwordless-section {\n    margin-top: 20px;\n    margin-bottom: 20px !important;\n}\n\n.margin-top-20 {\n    margin-top: 20px;\n}\n\n@media (max-width: 767px) {\n\n    .left-content,\n    .right-text-only {\n        width: 100%;\n    }\n\n    .full-height {\n        height: auto;\n    }\n\n    .right-text-only {\n        display: none !important;\n    }\n\n    .left-content {\n        display: flex !important;\n        flex-direction: column !important;\n        align-items: center !important;\n        justify-content: center !important;\n        height: 100vh;\n    }\n\n    .image-box-container {\n        display: none !important;\n    }\n\n    .position-relative {\n        margin-top: 88px;\n    }\n}\n\n@media (max-width: 1250px) {\n    .terms-privacy {\n        display: block !important;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 800px) {\n    .btn-custom div {\n        width: 85%;\n        text-align: left;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 932px) {\n    .image-box-container {\n        display: flex !important;\n        flex-direction: column !important;\n        align-items: center !important;\n        justify-content: unset !important;\n        overflow-y: auto !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
